import React from 'react';
import { mapRiskToEnglish as mapRiskToEnglishShared, formatRiskLabel as formatRiskLabelShared, type RiskLevel } from '../../../shared';

// Re-export RiskLevel type for backward compatibility
export type { RiskLevel };

interface RiskIndicatorProps {
  level: RiskLevel | null;
  className?: string;
}

/**
 * Reusable risk indicator component showing color-coded risk bars
 * Colors are preserved in print via PrintStyles component
 * - low: Green (#10b981)
 * - moderate: Yellow (#facc15)
 * - high: Red (#ef4444)
 * - imminent: Black (#000000)
 */
export const RiskIndicator = ({ level, className = '' }: RiskIndicatorProps) => {
  if (!level) return null;
  const colors = {
    low: "#10b981",
    moderate: "#facc15",
    high: "#ef4444",
    imminent: "#000000",
  };

  return (
    <div
      className={`h-4 w-16 ${className}`}
      style={{ backgroundColor: colors[level] }}
    />
  );
};

/**
 * Helper function to map French risk values to English enum
 * Re-exported from shared utils for backward compatibility
 */
export const mapRiskToEnglish = mapRiskToEnglishShared;

/**
 * Helper function to format risk label for display
 * Re-exported from shared utils for backward compatibility
 */
export const formatRiskLabel = formatRiskLabelShared;
